import { ForgotResetFormik } from 'components/views/pages/forgot-password/ForgotResetFormik';
import { useForgotPassword } from 'components/views/pages/forgot-password/useForgotPassword';

interface Props {
  close: () => void;
  initialEmail?: string;
}

export const CheckoutForgotPasswordForm = ({ close, initialEmail }: Props) => {
  const fp = useForgotPassword({
    navigateOnResetPasswordSuccess: () => {
      close();
    },
  });

  return <ForgotResetFormik {...fp} hasTopAppDivider={false} initialEmail={initialEmail} />;
};
